import { Group, Text } from '@mantine/core'
import React, { forwardRef, ReactElement } from 'react'

import { TAddressSearchOption } from './types'

export interface ItemProps
  extends React.ComponentPropsWithoutRef<'div'>,
    TAddressSearchOption {}

const SelectItem = (
  { item, value, isLoading, ...others }: ItemProps,
  ref,
): ReactElement => {
  return (
    <div ref={ref} {...others}>
      {isLoading ? (
        <div>{item.name1}...</div>
      ) : (
        <Group noWrap>
          <div style={{ whiteSpace: 'nowrap' }}>
            <Group noWrap>
              {item.barcode && (
                <Text size="sm" color="dimmed">
                  {item.barcode}
                </Text>
              )}
              <Text size="sm">
                {/* <Address oneliner address={value } /> */}
                {item.name1}
              </Text>
            </Group>
            {/* <Text size="xs">{description}</Text> */}
          </div>
        </Group>
      )}
    </div>
  )
}

export default forwardRef<HTMLDivElement, ItemProps>(SelectItem)
